import { IConfiguration } from "./IConfiguration";

export const DEV = {
	headerAuthWidgetsApiUrl: "https://findum-widgets-dev.sendum.com",
	headerAuthWidgetsApiVersion: "v1",
	baseApiPath: "widget",
	mqttPrefix: "sandbox-",
	awsRegion: "us-east-1",
	cognitoAuthWidgetsApiUrl: "https://pe7ltxo42e.execute-api.us-east-1.amazonaws.com",
	cognitoAuthWidgetsApiVersion: "dev",
	cognitoAuthApiUrl: "https://kna1z27e0g.execute-api.us-east-1.amazonaws.com",
	cognitoAuthApiVersion: "dev", // TODO replace to dev
	cognitoIdentityPoolId: "us-east-1:0c134af2-d34a-471d-9772-6f85610fe7d2",
	cognitoAuthProviderName: "login.sendum.myapp",
	voyagerApiUrl: 'https://opr1futji3.execute-api.us-east-1.amazonaws.com',
	voyagerApiVersion: 'dev'
} as IConfiguration;